import React from 'react';
import { Input } from '../developers/page-components/Input';
import { DISPUTE_FORM_FIELDS } from '../../constants/dispute/dispute-form';
import { ErrorContainer } from '../developers/page-components/ErrorContainer';
import clsx from 'clsx';
import { ISelectorData } from '../application/NewApplication';
import { TypeAttributes } from 'rsuite/cjs/internals/types';

interface Props {
	formik: any,
	fieldName: DISPUTE_FORM_FIELDS,
	label: string,
	placeholder: string,
	inputType: string,
	checkboxFieldName?: string,
	additionalClass?: string,
	data?: ISelectorData[],
	searchable?: boolean,
	placement?: TypeAttributes.Placement,
	readOnly?: boolean,
}

export const DisputeFormInputs = (props: Props): React.ReactElement => {
	const { formik, fieldName, label, placeholder, inputType, checkboxFieldName, additionalClass, data, searchable, placement, readOnly } = props;
	return (
		<>
			<div className="col-6 pt-4">{label}</div>
			<div className={clsx('dispute-input-container col-6 position-relative pb-8', additionalClass)}>
				<Input
					formik={formik}
					inputType={inputType}
					fieldName={fieldName}
					placeholder={placeholder}
					checkboxFieldName={checkboxFieldName}
					selectPickerData={data}
					searchable={searchable}
					placement={placement}
					readOnly={readOnly}
				/>
				<ErrorContainer formik={formik} fieldName={fieldName} additionClass="error-container"/>
			</div>
		</>
	);
};
